import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA4
    if (!window.GA_INITIALIZED) {
      ReactGA.initialize('G-YH0Q1D0H8H');
      window.GA_INITIALIZED = true;
    }
  }, []);

  useEffect(() => {
    // Track page views
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search, title: document.title });
  }, [location]);

  return null;
};

export default AnalyticsTracker;
